// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { productCarouselProductFullStyles } from "@guestsupply/Overrides/Components/ProductCarouselProductFull";
import { ellipsis } from "@guestsupply/XDL/Utilities";
import wrapInContainerStyles from "@insite/client-framework/Common/wrapInContainerStyles";
import { css } from "styled-components";

productCarouselProductFullStyles.wrapper = {
    css: css`
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
    `,
};

productCarouselProductFullStyles.imageWrapper = {
    css: css`
        justify-content: center;
    `,
};

productCarouselProductFullStyles.productImageStyles = {
    linkWrappingImage: {
        css: css`
            justify-content: center;
        `,
    },
};

productCarouselProductFullStyles.descriptionWrapper = {
    css: css`
        padding-block: 0;
    `,
};

productCarouselProductFullStyles.priceWrapper = {
    css: css`
        margin: 6px 0;
    `,
};

productCarouselProductFullStyles.productBrandWrapper = {
    css: css`
        margin: 6px 0;
        height: 15px;
    `,
};

productCarouselProductFullStyles.productBrandStyles = {
    nameLink: {
        color: "text",
    },
};

productCarouselProductFullStyles.productDescriptionStyles = {
    productDetailLink: {
        color: "text",
        typographyProps: {
            size: 14,
            lineHeight: "16px",
        },
        css: css`
            margin: 6px 0;
            line-height: 16px;
            ${ellipsis(3)}
        `,
    },
};

productCarouselProductFullStyles.productPartNumbersStyles = {
    container: {
        css: css`
            flex-grow: 0;
            margin-bottom: 6px;
        `,
    },
    erpNumberLabelText: { size: 12 },
    erpNumberValueText: { size: 12 },
};

productCarouselProductFullStyles.availabilityWrapper = {
    css: css`
        padding-block: 0;
        margin: 6px 0;
    `,
};

productCarouselProductFullStyles.productUnitOfMeasureSelectStyles = {
    labelProps: {
        css: css`
            flex: 1;
        `,
    },
    cssOverrides: {
        formInputWrapper: css`
            flex: 1;
        `,
    },
};

productCarouselProductFullStyles.productStandardActionsContainer = {
    gap: 6,
    css: css`
        padding-top: 12px;
    `,
};

productCarouselProductFullStyles.quantityOrderedGridItem = {
    width: 4,
};

productCarouselProductFullStyles.productQuantityOrderedStyles = {
    qtyFieldStyles: {
        editableQuantityTextField: {
            cssOverrides: {
                formField: css`
                    width: auto;
                `,
            },
        },
    },
};

productCarouselProductFullStyles.addToCartGridItem = {
    width: 8,
};

productCarouselProductFullStyles.productAddToCartButtonStyles = {
    css: css`
        width: 100%;
    `,
};

productCarouselProductFullStyles.addToListGridItem = {
    width: 12,
    css: css`
        justify-content: flex-end;
    `,
};

productCarouselProductFullStyles.productAddToListLinkStyles = {
    link: {
        typographyProps: { size: 13 },
        css: css`
            margin-bottom: 12px;
        `,
    },
};

productCarouselProductFullStyles.imageBadgeGridItem = {
    width: 12,
};

productCarouselProductFullStyles.textBadgeGridItem = {
    width: 12,
};

productCarouselProductFullStyles.badgeAreaWrapper = {
    css: css`
        position: relative;
    `,
};

productCarouselProductFullStyles.badgeTextWrapper = {
    css: css`
        position: absolute;
        width: 50%;
        white-space: nowrap;
        overflow: hidden;
    `,
};

productCarouselProductFullStyles.badgeImageWrapper = {
    css: css`
        position: absolute;
        width: 25%;
        height: 25%;
    `,
};

productCarouselProductFullStyles.badgeText = {
    weight: "bold",
    css: css`
        width: 100%;
        margin: auto;
        ${wrapInContainerStyles}
    `,
};
